<template>
  <div class="container">
    <table class="table">
      <thead>
        <tr>
          <th>Name</th>
          <!-- <th>Note Title</th> -->
          <th>Slug</th>
          <th>Published</th>
          <th>Update</th>
        </tr>
      </thead>
      <tbody>
        <tr>
          <td>{{ subject.name }}</td>
          <!-- <td>{{ subject.titleNote }}</td> -->
          <td>{{ subject.slug }}</td>
          <td>{{ subject.published }}</td>
          <td>{{ subject.updated }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import axios from "axios";
export default {
  data() {
    return {
      subject: [],
    };
  },
  mounted() {
    this.getSubject();
  },

  methods: {
    async getSubject() {
      // let response = await axios.get(
      //     "/api/notes/" + this.$route.params.noteSlug
      // );
      // this.note = response.data.data;
      let { data } = await axios.get("/api/subjects/" + this.$route.params.id);
      this.subject = data.data;
    },
  },
};
</script>
